import { API, graphqlOperation } from "aws-amplify";
import axios from "axios";
import handleError from "../../errorHandler";
import {
  GET_TMS_COURSES, GET_TMS_COURSES_SUCCESS, GET_TMS_COURSES_FAILURE,
  GET_TMS_LOGIN, GET_TMS_LOGIN_SUCCESS, GET_TMS_LOGIN_FAILURE,
  GET_TMS_LOGOUT, GET_TMS_LOGOUT_SUCCESS, GET_TMS_LOGOUT_FAILURE, STOP_TMS_API_PROPAGATION, TRIGGER_TOAST
} from "../constants";
import { GetTMSGetCourse } from "./../../queries";

const getTMSCourses = (uuId: string) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_TMS_COURSES });
    if (!!sessionStorage.getItem("isDemoUser")) {
      const dummyData = require("../../data/MockData/getTMsGetCourse.json");
      dispatch({ type: GET_TMS_COURSES_SUCCESS, payload: { ...dummyData } });
    }
    else {
      const getTMSCourse = API.graphql(graphqlOperation(GetTMSGetCourse, { uuId })) as Promise<any>;
      getTMSCourse
        .then((tmsCoursesResp: any) => {
          if (tmsCoursesResp && tmsCoursesResp.data) {

            dispatch({ type: GET_TMS_COURSES_SUCCESS, payload: { ...tmsCoursesResp } });

          } else {
            // handleError(err);tmsCoursesResp
            dispatch({ type: GET_TMS_COURSES_FAILURE });
            dispatch({
              type: TRIGGER_TOAST,
              payload: {
                shouldShow: true,
                severity: 'error',
                transMessage: "message_errorDefault"
              },
            });
          }
        })
        .catch((err) => {
          // handleError(err);
          dispatch({ type: GET_TMS_COURSES_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: 'error',
              transMessage: "message_errorDefault"
            },
          });
        });
    }
  };
};

const callTMSLogin = (learnerJWToken: string) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_TMS_LOGIN });
    const sessionURL = `${process.env.REACT_APP_TMS_URL}/login/session`;
    const data = JSON.stringify({ "id-token": learnerJWToken });
    const header = { headers: { "Content-Type": "text/plain" } };
    axios.post(sessionURL, data, {
      responseType: "text",
      headers: header.headers,
      withCredentials: true,
    }).then(() => {
      dispatch({ type: GET_TMS_LOGIN_SUCCESS, payload: { data: true } });
    }, (err: Error) => {
      // handleError(err);
      dispatch({ type: GET_TMS_LOGIN_FAILURE });
    })
  };
}

const callTMSLogOut = () => {
  return async (dispatch: any) => {
    dispatch({ type: GET_TMS_LOGOUT });
    const options = { headers: { "Content-Type": "text/plain" } };
    axios.get(`${process.env.REACT_APP_TMS_URL}/logout`, {
      headers: options.headers,
      responseType: "text",
    }).then(() => {
      dispatch({ type: GET_TMS_LOGOUT_SUCCESS, payload: { data: true } });
    }, (err: Error) => {
      // handleError(err);
      dispatch({ type: GET_TMS_LOGOUT_FAILURE });
    })
  };
}

const stopAPIPropagation = () => {
  return (dispatch: any) => {
    dispatch({ type: STOP_TMS_API_PROPAGATION });
  }
}

export default {
  getTMSCourses,
  callTMSLogin,
  callTMSLogOut,
  stopAPIPropagation
};
